<template>
	<div id="box">
		<div class="head">
			<div class="header">
				<el-row :gutter="24" type='flex' align='middle' style="padding:0;margin:0">
					<el-col :span="4" style="padding:0;margin:0">
						<img @click="handleSelect(1)" v-if='user.festival&&user.festival.id!=2058' style="height:60px;width:120px;cursor: pointer;" src="../assets/img/logo.png"/>
						<span @click="handleSelect(1)" class='ell_box' v-else style="font-size:24px;font-weight:600">{{user.festival?user.festival.name:''}}</span>
					</el-col>
				  	<el-col :span="20" style="padding:0;margin:0">
						  <div style="text-align:right" class="navvv" v-if="user">
							<span v-if='user&&user.festival.type==2&&user.festival.id!=$store.state.hidePriceid' >
								金额：
								<span>
									<img style="width:16px;height:16px;background:white;position:relative;top:2px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
									<img style="width:16px;height:16px;background:white;position:relative;top:2px;" v-if="!user.festival||!user.festival.priceSymbol" src="../assets/img/pindou.png" />
									<span style="font-size:14px;color:#0A1132;font-weight:600">{{balance/100}}</span>
									<span style="color:#FB3F45;font-weight:600;margin-left:2px" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
								</span>
								
							</span>
							<span v-if='user&&user.festival.type==1&&user.festival.id!=$store.state.hidePriceid'>兑换次数：<span style="font-size:20px;color:#0A1132">{{validTimes}}</span>次</span>
							<span class="fgx" v-if='user&&user.festival.type==2&&user.festival.id!=$store.state.hidePriceid'></span>
							<span class="cart_box" @click="bindcart" >
									<img src="../assets/img/cart.png" alt="" style="height:16px;width:16px;margin-right:4px;">
									<span>购物车</span>
							</span>
							
							<span class="fgx"></span>
							<span v-if='user.festival&&user.festival.id!=$store.state.hidePriceid'>有效期至：{{user.cardDate}}</span>
							<span v-else>有效期至：2021-09-30</span>
							<span class="fgx"></span>
							<span>NO.{{user.cardNo}}</span>
							<span class="fgx"></span>
							<span class="tctc" style="cursor: pointer;" @click="bindoutlogin">退出</span>
						  </div>
						
				  	</el-col>
				</el-row>
			</div>
		</div>
		<div class="fffoot">
		<div class="foot">
			COPYRIGHT © 2016-2017 PINUC.COM ALLRIGHTS RESERVED 咨询电话：400-007-6666 （09:00-21:00）
		</div>
		</div>
		<router-view ></router-view>
		
	</div>
</template>
<script>
import router from '../router'
import axios from 'axios'
import getCurrentCityName from '../js/map'
import store from '../store'
import $ from 'jquery'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { formatDate, formatTimeToStr } from '../js/data'
import md5 from 'js-md5'
//import {INCREMENT,MSG} from '../mutation-types';
export default {
  //		name: 'index',
  data() {
    return {
      user: ''
    }
  },
  beforeMount: function() {},
  mounted() {
    // festivalCategories
    var user = sessionStorage.getItem('user')
    console.log(JSON.parse(user))
    if (user) {
      var users = JSON.parse(user)
      users.festival.endDate = users.festival.endDate ? formatTimeToStr(users.festival.endDate, 'yyyy-MM-dd') : ''
      users.cardDate = users.cardDate ? formatTimeToStr(users.cardDate, 'yyyy-MM-dd') : ''
      this.user = users
      if (users.festival.id == 2058) {
        document.title = '福利兑换页'
      }
    } else {
      this.$router.push({ path: '/login' })
    }
  },
  updated() {},
  methods: {
    bindcart() {
      var cart_list = localStorage.getItem('cart_list')
      var list = cart_list ? JSON.parse(cart_list) : []
      // list.forEach((item)=>{
      // 	item.show = false
      // })
      localStorage.setItem('cart_list', JSON.stringify(list))
      this.$router.push({ path: '/cart' })
    },
    getUser() {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.getCardUserBalance({}, headers).then((res) => {
        console.log('', res)
        if (res.code == 0) {
          var user = this.user
          this.$store.state.cardDate = res.data.default.cardDate
          this.$store.state.validTimes = res.data.default.validTimes
          this.$store.state.balance = res.data.default.balance
          sessionStorage.setItem('user', JSON.stringify(user))
        }
      })
    },
    bindmounted() {
      if (this.$route.path == '/') {
        this.activeIndex = '1'
      }
      if (this.$route.path == '/special_gift' || this.$route.path == '/gift') {
        this.activeIndex = '2'
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      if (key == 1) {
        this.$router.push({ path: '/' })
      }
      if (key == 2) {
        this.$router.push({ path: '/special_gift' })
      }
    },
    bindoutlogin() {
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.setItem('user', '')
        sessionStorage.setItem('pageNumber', '')
        sessionStorage.setItem('pageNumber1', '')
        this.$store.commit('setFestivalCityId', '')
        this.$store.commit('setCityList', '')
        this.$store.state.validTimes = 0
        this.$store.state.balance = 0
        this.$router.push({ path: '/login' })
      })
    }
  },
  components: {},
  computed: {
    ...mapState(['validTimes']),
    ...mapState(['balance']),
    ...mapState(['cardDate'])
  }
}
</script>
<style lang="scss" scoped="scoped">
.cart_box {
  cursor: pointer;
}
.tctc:hover {
  color: #f3a251 !important;
}
.navvv {
  span {
    color: #909199;

    font-size: 14px;
  }
  .fgx {
    display: inline-block;
    height: 12px;
    width: 1px;
    background: #909199;
    margin: 0 10px;
  }
}
#box {
  .head {
    height: 80px;
    .header {
      width: 1260px;
      height: 100%;
      margin: auto;
      display: flex;
      align-items: center;
      .el-row {
        width: 1260px;
      }
      .el-menu--horizontal > .el-menu-item {
        color: white !important;
        font-size: 16px;
      }
      .el-menu--horizontal > .el-menu-item.is-active {
        border-color: white !important;
        background: rgb(255, 92, 77) !important;
      }
      .el-menu-item {
        padding: 0;
        margin: 0 20px;
      }
      .el-menu.el-menu--horizontal {
        border: none;
        margin-bottom: 10px;
        li {
          height: 50px;
          line-height: 50px;
        }
        li:hover {
          border-color: white !important;
          background: rgb(255, 92, 77) !important;
        }
      }
      .el-avatar {
        background: white;
      }
    }
  }
  position: relative;
  // padding-bottom:20px;
  .fffoot {
    position: absolute;
    bottom: -40px;
    background: #f7f7f7;
    width: 100%;
    .foot {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #f0f0f0;
      font-size: 12px;
      background: #414141;
      color: #999999;
    }
    .f-footer-section {
      width: 1200px;
      margin: auto;
      /*margin-top:80px;*/
      height: 100px;
      display: flex;
      justify-content: space-between;
    }
    .f-footer-list {
      width: 70%;
      color: #030303;
      font-size: 13px;
      padding: 30px;
      text-align: left;
    }
    .f-footer-list li {
      display: inline-block;
      padding: 0 10% 0 40px;
    }
    .f-footer-list li dd {
      font-weight: 600;
    }
    .f-footer-list li dt {
      padding-top: 5px;
    }
    .f-footer-list li dt a {
      color: #666;
    }
    .f-footer-service {
      padding: 27px 0;
      display: flex;
      align-items: center;
    }
    .f-footer-service b {
      font-size: 35px;
      color: #030303;
    }
    .f-footer-service em {
      font-size: 35px;
      color: #666;
      padding: 0 10px;
      font-style: normal;
    }
    .f-footer-service span {
      display: inline-block;
    }
    .f-footer-service span i {
      display: block;
      font-size: 13px;
      color: #666;
    }
    .f-footer-address {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #f0f0f0;
      background: #3a3637;
    }
    .f-third-footer {
      width: 67%;
      padding: 30px 0;
    }
    .f-third-footer li {
      padding: 0 5% 0 0;
    }
  }
}
</style>
